import { useState } from "react";
import Stats from "./stats";
import QuickActions from "./quickActions";
import Onboarding from "../onboarding";
import VisaExpiryList from "./visaExpiryList";

const Overview = () => {
    const [showOnboarding, setShowOnboarding] = useState(window.localStorage.getItem("showOnboarding"));

    return (
        <div>
            {showOnboarding === "true" && <Onboarding />}
            <Stats />
            <QuickActions />
            <div className="grid grid-cols-3 gap-4 mt-4">
                <div className="col-span-3 sm:col-span-2">
                    <VisaExpiryList />
                </div>
            </div>
        </div>
    );
};
export default Overview;